<template>
    <div class="login-body">
        <div class="login-image">
            <img :src="'layout/images/pages/login-on' + color + '.png'" alt="GA Moosehead" />
        </div>
        <div class="login-panel p-fluid grid">
            <div class="flex-column col-4">
                <div class="flex align-items-center logo-container">
                    <img :src="'layout/images/logo-' + color + '.png'" class="login-logo" />
                    <img :src="'layout/images/appname-' + color + '.png'" class="login-appname" />
                </div>
                <form @submit="this.signUpWithEmailAndPassword">
                    <h4 class="pb-3">Sign Up</h4>
                    <div
                        class="mb-3 border bg-warning border-warning rounded"
                        style="--bs-bg-opacity: 0.2"
                        v-if="!!this.message"
                    >
                        {{ this.message }}
                    </div>
                    <div>
                        <div class="grid mb-3 mr-3">
                            <label class="form-label col-4" for="first_name">First Name:</label>
                            <input
                                class="form-control col-8"
                                type="text"
                                name="first_name"
                                id="first_name"
                                v-model="this.first_name"
                                placeholder="First"
                                required
                            />
                        </div>
                        <div class="grid mb-3 mr-3">
                            <label class="form-label col-4" for="last_name">Last Name:</label>
                            <input
                                class="form-control col-8"
                                type="text"
                                name="last_name"
                                id="last_name"
                                v-model="this.last_name"
                                placeholder="Last"
                                required
                            />
                        </div>
                        <div class="grid mb-3 mr-3">
                            <label class="form-label col-4" for="email">Email:</label>
                            <input
                                class="form-control col-8"
                                type="email"
                                name="email"
                                id="email"
                                v-model="this.email"
                                placeholder="name@example.com"
                                required
                            />
                        </div>
                        <div class="grid mr-3">
                            <label class="form-label col-4" for="password">Password:</label>
                            <input
                                :type="this.isPasswordVisible ? 'text' : 'password'"
                                class="form-control col-8"
                                name="password"
                                placeholder="password"
                                v-model="this.password"
                                required
                            />
                        </div>
                        <input
                            class="form-check-input mb-3 align-self-end"
                            type="checkbox"
                            aria-label="Checkbox for following text input"
                            v-model="this.isPasswordVisible"
                        />Show
                        <div class="d-flex justify-content-center align-items-center mb-3">
                            <Button class="btn btn-primary" type="submit" label="Sign Up" />
                        </div>
                        <div>
                            <span class="ms-3 text-end"
                                >Already registered? <router-link to="/login">Log In</router-link></span
                            >
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="login-footer flex align-items-center">
        <AppFooter :colorScheme="color" />
    </div>
</template>

<script>
import AppFooter from '@/AppFooter.vue';

export default {
    name: 'SignUp',
    components: { AppFooter },
    data() {
        return {
            first_name: '',
            last_name: '',
            email: this.$route.query.email || '',
            password: '',
            message: '',
            isPasswordVisible: false,
            color: this.$appState.defaultColorScheme,
        };
    },
    methods: {
        async signUpWithEmailAndPassword(event) {
            event.preventDefault();

            const formData = {
                email: this.email,
                password: this.password,
                displayName: this.first_name + ' ' + this.last_name,
            };

            try {
                await this.$store.dispatch('signUpWithEmailAndPassword', formData);
            } catch (error) {
                this.message = error.message;
            }
        },
    },
};
</script>
